<template>
  <b-row class="app-section">
    <b-col class="h-100 p-3" style="overflow-y: scroll;">
      <b-card
        align="left"
        v-for="inst in instrumentsList"
        :key="`${inst.reference_designator}--dapage`"
        class="da-inst-card"
        body-class="da-card-body"
      >
        {{inst}}
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex';
// import store from '@/store.js';
import axios from 'axios';
import _ from 'lodash';
import { APIBASEURL, APIDA, APIMETADATA } from '../../utils/constants';

export default {
  data() {
    return {
      instrumentsList: [],
      responseObj: {},
    };
  },
  mounted() {
    this.allInstruments();
  },
  computed: {
    ...mapState({
      instruments: (state) => state.instruments,
    }),
  },
  methods: {
    allInstruments() {
      const filterInst = _.filter(this.instruments, ['harvest_flag', true]);
      this.instrumentsList = filterInst;
      const DAGET = filterInst.map((o) => this.getDA(o.reference_designator));
      return DAGET;
    },
    getDA(refdes) {
      // const getURL =
      axios
        .get(`${APIBASEURL}/${APIMETADATA}/${APIDA}`, {
          params: {
            ref: refdes,
            average: false,
            resolution: 'monthly',
          },
        })
        .then((response) => {
          this.responseObj = response.data;
          // console.log(this.responseObj);
          // console.log(response);
        });
    },
  },
};

</script>
